import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';

// ─── Emirates Order Summary Table (simple) ──────────────────────────
const EMIRATES_LIST = ['SHJ', 'DXB', 'AJM', 'UAQ', 'AUH', 'RAK', 'FHJ'];
const EMIR_COLS = [
    { key: 'toBeAssigned', label: 'TB', shaded: false },
    { key: 'onTheRoad', label: 'OR', shaded: false },
    { key: 'delivered', label: 'DV', shaded: false },
    { key: 'cancelled', label: 'CN', shaded: false },
    { key: 'total', label: 'Total', shaded: true },
    { key: 'onTimeDeliveryInPer', label: 'OD(%)', shaded: false },
];

const normalizeEmirate = (name) => {
    if (!name) return '';
    const n = name.trim().toLowerCase();
    if (n === 'sharjah' || n === 'shj') return 'shj';
    if (n === 'dubai' || n === 'dxb') return 'dxb';
    if (n === 'ajman' || n === 'ajm') return 'ajm';
    if (n === 'umm al quwain' || n === 'uaq' || n === 'um al quwain') return 'uaq';
    if (n === 'abu dhabi' || n === 'auh' || n === 'abu dh.' || n === 'abu dh') return 'auh';
    if (n === 'ras al khaimah' || n === 'rak') return 'rak';
    if (n === 'fujairah' || n === 'fhj' || n === 'fujeirah') return 'fhj';
    return n;
};

const EmiratesOrderTable = ({ data = [], hubName }) => {
       //alert(JSON.stringify(data));
    const lookup = {};
    (Array.isArray(data) ? data : []).forEach(row => {
        if (row?.emirates) {
            const normalized = normalizeEmirate(row.emirates);
            if (!lookup[normalized]) {
                lookup[normalized] = { ...row };
            } else {
                EMIR_COLS.forEach(({ key }) => {
                    if (key !== 'onTimeDeliveryInPer') {
                        lookup[normalized][key] = (lookup[normalized][key] ?? 0) + (row[key] ?? 0);
                    }
                });
                lookup[normalized].onTimeDeliveryInPer = Math.round(
                    ((lookup[normalized].onTimeDeliveryInPer ?? 0) + (row.onTimeDeliveryInPer ?? 0)) / 2
                );
            }
        }
    });

    const getVal = (emirate, key) => {
        const row = lookup[normalizeEmirate(emirate)];
        return row ? (row[key] ?? 0) : 0;
    };

    const allTotals = {};
    EMIR_COLS.forEach(({ key }) => {
        if (key === 'onTimeDeliveryInPer') {
            const validEmirates = EMIRATES_LIST.filter(em => lookup[normalizeEmirate(em)]);
            const totalOtd = validEmirates.reduce((sum, em) => sum + getVal(em, key), 0);
            allTotals[key] = validEmirates.length > 0 ? Math.round(totalOtd / validEmirates.length) : 0;
        } else {
            allTotals[key] = EMIRATES_LIST.reduce((sum, em) => sum + getVal(em, key), 0);
        }
    });

    const hCell = { padding: '6px 10px', textAlign: 'center', fontWeight: 'bold', fontSize: 11, color: '#fff', backgroundColor: '#1a2b4a', borderRight: '1px solid #2e4070', whiteSpace: 'nowrap' };
    const dCell = (shaded, isFirst = false) => ({ padding: '5px 10px', textAlign: isFirst ? 'left' : 'center', fontSize: 11, fontWeight: isFirst ? 'bold' : 'normal', backgroundColor: shaded ? '#e8e8e8' : '#fff', borderRight: '1px solid #ddd', borderBottom: '1px solid #eee', color: '#333' });
    const aCell = (shaded, isFirst = false) => ({ ...dCell(shaded, isFirst), backgroundColor: shaded ? '#cacaca' : '#f0f0f0', fontWeight: 'bold', borderTop: '2px solid #1a2b4a' });

    return (
        <Card variant="outlined" sx={{ width: '100%', height: '100%', borderRadius: 2 }}>
            <CardContent sx={{ padding: '12px !important' }}>
                <Typography variant="h6" style={{ fontSize: 14, fontWeight: 'bold', color: '#32CA73', textAlign: 'left', borderBottom: '2px solid #32CA73', paddingBottom: 6, marginBottom: 8 }}>
                    {hubName} - TODAY'S EMIRATE WISE ORDERS
                </Typography>
                <Box sx={{ overflowX: 'auto' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', tableLayout: 'fixed' }}>
                        <thead>
                            <tr>
                                <th style={{ ...hCell, textAlign: 'left', width: '23%' }}>Emirate</th>
                                {EMIR_COLS.map(col => <th key={col.key} style={{ ...hCell, backgroundColor: col.shaded ? '#2e4070' : '#1a2b4a' }}>{col.label}</th>)}
                            </tr>
                        </thead>
                        <tbody>
                            {EMIRATES_LIST.map((em, i) => (
                                <tr key={em} style={{ backgroundColor: i % 2 === 0 ? '#fff' : '#fafafa' }}>
                                    <td style={dCell(false, true)}>{em}</td>
                                    {EMIR_COLS.map(col => <td key={col.key} style={dCell(col.shaded)}>{getVal(em, col.key)}</td>)}
                                </tr>
                            ))}
                            <tr>
                                <td style={aCell(false, true)}>ALL</td>
                                {EMIR_COLS.map(col => <td key={col.key} style={aCell(col.shaded)}>{allTotals[col.key]}</td>)}
                            </tr>
                        </tbody>
                    </table>
                </Box>
                <Typography sx={{ fontSize: 10, color: '#666', mb: 0.5 }}>
                    TB = To be Assigned&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;OT = On the Road&nbsp;&nbsp;
                    <br/>DV = Delivered&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;CA = Cancelled&nbsp;&nbsp;
                    <br/>OD = On Time Delivery %
                </Typography>

            </CardContent>
        </Card>
    );
};

export default EmiratesOrderTable;
